module.exports = __webpack_public_path__ + "img/msg-revoke.920c8fae.svg";